import * as THREE from 'three';
import { DimensionsType } from '../types';
import { TextObject } from './TextObject';

type PropsConstructor = {
  startPoint: THREE.Vector3;
  endPoint: THREE.Vector3;
};

export class Dimensions extends THREE.Group implements DimensionsType {
  static direct = new THREE.Vector3(1, 0, 0);
  static heightBetweenLine = 0.2;
  private offsetY = 0.05;
  startPoint: THREE.Vector3;
  endPoint: THREE.Vector3;
  visible = true;

  constructor({ startPoint, endPoint }: PropsConstructor) {
    super();
    this.startPoint = startPoint; //.setY(startPoint.y - this.offsetY);
    this.endPoint = endPoint; //.setY(endPoint.y - this.offsetY);
    this.buildGroup();
  }

  buildGroup() {
    const dir = this.endPoint.clone().sub(this.startPoint);
    const dir90 = dir
      .clone()
      .applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2)
      .normalize();
    const p1 = this.startPoint
      .clone()
      .setY(this.startPoint.y - this.offsetY)
      .add(dir90.clone().multiplyScalar(Dimensions.heightBetweenLine));
    const p2 = this.endPoint
      .clone()
      .setY(this.endPoint.y - this.offsetY)
      .add(dir90.clone().multiplyScalar(Dimensions.heightBetweenLine));
    const lineLeft = this.getLine(
      this.startPoint.clone().setY(this.startPoint.y - this.offsetY),
      p1
    );
    const lineRight = this.getLine(this.endPoint.clone().setY(this.endPoint.y - this.offsetY), p2);
    this.add(lineLeft, lineRight);
    this.getArrow(p1, p2);
    this.getTextDimensions(p1, p2);
    this.setVisible();
  }
  rebuildGroup(p1: THREE.Vector3, p2: THREE.Vector3) {
    this.startPoint.copy(p1); //.setY(p1.y - this.offsetY);
    this.endPoint.copy(p2); //.setY(p2.y - this.offsetY);
    this.removeChildrenGroup();
    this.buildGroup();
  }
  removeChildrenGroup() {
    while (this.children.length > 0) {
      const findObj = this.children[0];
      if (findObj) {
        findObj.parent?.remove(findObj);
      }
    }
  }
  setVisible(): void {
    this.children.forEach(item => {
      item.visible = this.visible;
    });
  }

  private getLine(p1: THREE.Vector3, p2: THREE.Vector3): THREE.Line {
    const points = [p1, p2];
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    const material = new THREE.LineBasicMaterial({ color: 0x000000 });
    return new THREE.Line(geometry, material);
  }
  private getArrow(p1: THREE.Vector3, p2: THREE.Vector3): void {
    const headLength = 0.1;
    const headWidth = 0.05;
    const direct = p2.clone().sub(p1).normalize();
    const dist = p1.distanceTo(p2);
    const midPoint = p1.clone().add(direct.clone().multiplyScalar(dist / 2));
    const arrow1 = new THREE.ArrowHelper(
      direct.clone(),
      midPoint,
      dist / 2,
      0x000000,
      headLength,
      headWidth
    );
    const arrow2 = new THREE.ArrowHelper(
      direct.clone().negate(),
      midPoint,
      dist / 2,
      0x000000,
      headLength,
      headWidth
    );
    this.add(arrow1, arrow2);
    // return new THREE.ArrowHelper(direct.clone(), startPoint, length, 0x000000);
  }
  private getTextDimensions(p1: THREE.Vector3, p2: THREE.Vector3) {
    const nullVector = new THREE.Vector3(1, 0, 0);
    const direct = p2.clone().sub(p1).normalize();

    const dir90 = direct.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2);
    const dist = p1.distanceTo(p2);
    const midPoint = p1
      .clone()
      .add(direct.clone().multiplyScalar(dist / 2))
      .add(dir90.clone().multiplyScalar(0.08));
    const text = new TextObject(`${(dist * 1000).toFixed(0)} mm`, 0.1);
    const angle = nullVector.angleTo(direct);
    if (angle >= Math.PI - Math.PI / 4) {
      text.lookAt(dir90);
    } else {
      text.lookAt(dir90.negate());
    }
    text.position.copy(midPoint);
    this.add(text);
  }
}
